import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const GuestContext = createContext();

const apiBaseUrl = process.env.REACT_APP_SERVER_URL;

export const GuestProvider = ({ children }) => {
    const [guestMessageCount, setGuestMessageCount] = useState(0);
    const [guestChatId, setGuestChatId] = useState(null);
    const [isLimitReached, setIsLimitReached] = useState(false);
    const [guestLimit, setGuestLimit] = useState(5);

    const fetchGuestSession = useCallback(async () => {
        try {
            const { data } = await axios.get(`${apiBaseUrl}/api/guest/session`, {
                withCredentials: true,
            });
            setGuestMessageCount(data.messageCount);
            setGuestLimit(data.limit);
            setIsLimitReached(data.limitReached);
        } catch (error) {
            console.error('Error fetching guest session:', error);
        }
    }, []);

    useEffect(() => {
        fetchGuestSession();
    }, [fetchGuestSession]);

    const createGuestChat = async () => {
        const { data } = await axios.post(`${apiBaseUrl}/api/guest/chats`, {}, {
            withCredentials: true,
        });
        setGuestChatId(data.chat_id);
        return data;
    };

    const sendGuestMessage = async (chatId, text,captchaToken) => {
        const { data } = await axios.post(`${apiBaseUrl}/api/guest/chats/${chatId}/messages`, {
            text,
            sender: 'user',
            captchaToken 
        }, {
            withCredentials: true,
        });

        setGuestMessageCount(data.messageCount);
        setIsLimitReached(data.limitReached);
        return data;
    };

    const getGuestChat = async (chatId) => {
        const { data } = await axios.get(`${apiBaseUrl}/api/guest/chats/${chatId}`, {
            withCredentials: true,
        });
        return data;
    };

    const resetGuestState = () => {
        setGuestChatId(null);
        setGuestMessageCount(0);
        setIsLimitReached(false);
    };

    return (
        <GuestContext.Provider value={{
            guestMessageCount,
            guestChatId,
            isLimitReached,
            guestLimit,
            fetchGuestSession,
            createGuestChat,
            sendGuestMessage,
            getGuestChat,
            resetGuestState
        }}>
            {children}
        </GuestContext.Provider>
    );
};

export const useGuest = () => useContext(GuestContext);
